import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getBusCourses = ({ id, ...params }) => {
  return api.get(`admin/bus-courses-v2`, {
    params,
  });
};

export const getBusCoursesQueryOptions = params => {
  return queryOptions({
    queryKey: ["bus-courses", params],
    queryFn: () => getBusCourses(params),
  });
};

export const useBusCoursesQuery = ({ queryConfig = {}, ...params }) => {
  return useQuery({
    ...getBusCoursesQueryOptions(params),
    ...queryConfig,
  });
};
